import { supabase } from '../supabase/supabase';

class Logger {
  async log(level, message, context = {}) {
    console[level === 'error' ? 'error' : 'log'](`[${level.toUpperCase()}] ${message}`, context);
    
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      await supabase.from('system_logs_2024').insert([{
        level,
        message,
        context: {
          ...context,
          url: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString()
        },
        coach_id: user?.id || null
      }]);
    } catch (err) {
      // Fallback if logging to DB fails
      console.error('Failed to save log to database:', err);
    }
  }

  error(message, context) { return this.log('error', message, context); }
  warn(message, context) { return this.log('warn', message, context); }
  info(message, context) { return this.log('info', message, context); }
  debug(message, context) { return this.log('debug', message, context); }
}

export const logger = new Logger();

// Global handler for uncaught errors
window.onerror = (message, source, lineno, colno, error) => {
  logger.error('Uncaught Runtime Error', { message, source, lineno, colno, stack: error?.stack });
};

window.onunhandledrejection = (event) => {
  logger.error('Unhandled Promise Rejection', { reason: event.reason });
};